import { DEFAULT_AVATAR_STATE } from "@/game/avatar/state";
import { AvatarState } from "../types/avatar";

export const createDefaultAvatarState = (): AvatarState => {
  return {
    ...DEFAULT_AVATAR_STATE,
    slots: {
      ...DEFAULT_AVATAR_STATE.slots,
    },
  };
};
